import axios, { AxiosError } from "axios";

const BASE = import.meta.env.VITE_API_BASE || "https://teach.gim94.ru/api/gordost";

export const api = axios.create({
  baseURL: BASE,
  timeout: 30000,
});

// Request: attach JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gordost_parent_jwt");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response: 401 → wipe token + redirect to /login (preserve original path)
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("gordost_parent_jwt");
      if (window.location.pathname !== "/login") {
        const redirect = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?redirect=${redirect}`;
      }
    }
    return Promise.reject(error);
  }
);

export function setParentJwt(token: string) {
  localStorage.setItem("gordost_parent_jwt", token);
}

export function getParentJwt(): string | null {
  return localStorage.getItem("gordost_parent_jwt");
}

export function clearParentJwt() {
  localStorage.removeItem("gordost_parent_jwt");
}

export function isAuthenticated(): boolean {
  return getParentJwt() !== null;
}
